import kebabCase from 'lodash/kebabCase'
const iconLibraryNames = []
const iconNames = require.context('./', false, /[\w]+Icon\.vue$/)
iconNames.keys().forEach(fileName => {
  const names = kebabCase(fileName.replace(/^\.\/(.+)Icon\.vue/, '$1'))
  iconLibraryNames.push(names)
})

export default iconLibraryNames
